import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';

const Vacation = () => {
    const [holidayYear, setHolidayYear] = useState(10);
    const [holidayExpense, setHolidayExpense] = useState(100000);
    const [inflationRate, setInflationRate] = useState(6);
    const [expectedReturn, setExpectedReturn] = useState(12);
    const [result, setResult] = useState(null);

    const calculateVacation = () => {
        const futureCost = holidayExpense * Math.pow(1 + inflationRate / 100, holidayYear);

        // SIP Calculation
        const sipMonths = holidayYear * 12;
        const monthlyRate = expectedReturn / 100 / 12;
        const sipAmount = futureCost * (monthlyRate) / (Math.pow(1 + monthlyRate, sipMonths) - 1);

        // Lumpsum Calculation
        const lumpsum = futureCost / Math.pow(1 + expectedReturn / 100, holidayYear);

        setResult({
            futureCost,
            sipAmount,
            lumpsum,
        });
    };

    const pieData = result && {
        labels: ['SIP Investment', 'Lumpsum Investment'],
        datasets: [
            {
                data: [result.sipAmount * holidayYear * 12, result.lumpsum],
                backgroundColor: ['#004aad', '#76d041'],
            },
        ],
    };

    return (
        <div className="sip-calculator">
            <h2>Vacation Planning Calculator</h2>

            <div className="input-group">
                <label>After how many years do you wish to go on your holiday?</label>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={holidayYear}
                    onChange={(e) => setHolidayYear(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="0"
                    max="100"
                    value={holidayYear}
                    onChange={(e) => {
                        const val = e.target.value;
                        setHolidayYear(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Current Expenses In Holidays?</label>
                <input
                    type="range"
                    min="0"
                    max="5000000"
                    step="10000"
                    value={holidayExpense}
                    onChange={(e) => setHolidayExpense(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="0"
                    max="5000000"
                    value={holidayExpense}
                    onChange={(e) => {
                        const val = e.target.value;
                        setHolidayExpense(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Expected Inflation Rate (%)</label>
                <input
                    type="range"
                    min="0"
                    max="100"
                    step=".1"
                    value={inflationRate}
                    onChange={(e) => setInflationRate(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="0"
                    max="100"
                    step=".1"
                    value={inflationRate}
                    onChange={(e) => {
                        const val = e.target.value;
                        setInflationRate(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Expected Returns (%)</label>
                <input
                    type="range"
                    min="0"
                    max="100"
                    step=".1"
                    value={expectedReturn}
                    onChange={(e) => setExpectedReturn(Number(e.target.value))}
                />
                <input
                    type="number"
                    min="0"
                    max="100"
                    step=".1"
                    value={expectedReturn}
                    onChange={(e) => {
                        const val = e.target.value;
                        setExpectedReturn(val === '' ? '' : Number(val));
                    }}
                    className="value-box"
                />
            </div>

            <button onClick={calculateVacation} className="calculate-btn">
                Calculate
            </button>

            {result && (
                <div className="sip-output-section">
                    <div className="result-summary">
                        <h3>Results After {holidayYear} Years:</h3>
                        <p> Vacation Expenses Would Be: <strong style={{color:'#76d041'}}>₹{result.futureCost.toLocaleString()}</strong></p>
                        <p> Planning Through SIP: <strong style={{color:'#76d041'}}>₹{result.sipAmount.toFixed(0)}</strong>/month</p>
                        <p> Planning Through Lumpsum: <strong style={{color:'#76d041'}}>₹{result.lumpsum.toFixed(0)}</strong></p>
                    </div>
                    <div className="pie-chart-container">
                        <h3>SIP vs Lumpsum</h3>
                        <Pie data={pieData} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Vacation;
